import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminContentPublishing from "@/pages/admin/AdminContentPublishing";

export const Route = createFileRoute("/admin/content/")({
  head: () => pageHead("Admin \u2014 Content \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminContentPublishing,
});
